export const lungs = (() => {
    const placeHolderText = 'CTA B/L with good aeration'

    return placeHolderText
})